<!-- 

  *************
  *
  * 추가 개발 나오기 전까지 임시로 사용..
  *
  *
  *
  *
  *
  *
  *************
 -->
<template>
  <span class="dropdown guide_page">
      <span>
          <table>
              <colgroup>
                  <col width="100"/>
                  <col width=""/>
              </colgroup>
              <thead>
                  <tr>
                      <th>상태</th>

                      <th>내용</th>
                  </tr>
              </thead>
              <!-- 수주/외주 계약 상태 -->
              <tbody v-if="type === 'ordersStateNm' || type === 'outsStateNm'">
                  <tr>
                      <td><span class="state_type state1">계획</span></td>
                      <td><span class="guide_msg">계약되기 전 생성 시점에 설정(대기와 동일함)</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state3 wd">계약완료</span></td>
                      <td><span class="guide_msg">계약서가 생성되는 시점</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state4">진행</span></td>
                      <td><span class="guide_msg">계약서 내용을 토대로 사업이 진행 중이거나 선금 청구가 완료된 단계</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state2 wd">검사검수</span></td>
                      <td><span class="guide_msg">준공 단계에서 검수조서 업로드 또는 행정적 절차를 진행 중인 단계</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state6">발행</span></td>
                      <td><span class="guide_msg">검사검수 단계가 완료되거나, 선금 청구 등으로 세금계산서 발행/요청 후 입금/지급 처리 단계</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state5">완료</span></td>
                      <td><span class="guide_msg">입금까지 완료된 상태</span></td>
                  </tr>
              </tbody>
              <!-- 프로젝트 상태 -->
              <tbody v-if="type === 'projStateNm'">
                  <tr>
                      <td><span class="state_type state1">대기</span></td>
                      <td><span class="guide_msg">프로젝트 최초 등록 시 상태</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state3">진행</span></td>
                      <td><span class="guide_msg">계약 건 등록 등 진행될 때 상태</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state4">준공</span></td>
                      <td><span class="guide_msg">프로젝트 관련 구축이 모두 완료된 상태로 준공계 접수 시점 기준, 모든 계약 건들이 종료되지 않은 상태</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state5">완료</span></td>
                      <td><span class="guide_msg">프로젝트와 연결된 모든 계약 건들이 완료 상태로 변경될 때 프로젝트 최종 완료</span></td>
                  </tr>
              </tbody>
              <!-- 영업 상태 -->
              <tbody v-if="type === 'selesStateNm'">
                  <tr>
                      <td><span class="state_type state1">기회</span></td>
                      <td><span class="guide_msg">발주처에서 회사에 업무 협의나 소개 자료를 요청 했을 때</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state2">고려</span></td>
                      <td><span class="guide_msg">수행 가능한 업체로 인지하고, 타 회사 비교 자료와 설계서를 요청했을 때</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state3">적극</span></td>
                      <td><span class="guide_msg">추가적인 업무 협의, 과업지시서, 구체적인 설계 문서가 전달 되었을 때</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state4">확실</span></td>
                      <td><span class="guide_msg">계약방법, 사업 수행방안, 시기 등의 구체적인 사안을 논의하는 단계</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state5">수주</span></td>
                      <td><span class="guide_msg">사업이 수주 완료 되었을 때</span></td>
                  </tr>
                  <tr>
                      <td><span class="state_type state0">실패</span></td>
                      <td><span class="guide_msg">실주 등의 이유로 수주에 실패했을 때</span></td>
                  </tr>
              </tbody>
          </table>
      </span>

  </span>
    
</template>
  
<script setup>
  import { defineProps } from 'vue';

  defineProps({
    type: {
          type: String,
          required: true
      },
  })
</script>
  
<!-- 바꾸셔도 됩니당. -->
<style scoped lang="scss">
  
  .state_type {
        padding: 6px 16px;
        color: $gmx-font-white-color;
        border-radius: $border-radius1;

        &.drop_state_type {
            padding: 4px 16px;
        }

        &.state1 {
        background-color: $state-color1;
        }
        
        &.state2 {
            background-color: $state-color2;
            &.wd {
                padding: 6px 8px;
            }
        }
  
        &.state3 {
            background-color: $state-color3;

            &.wd {
                padding: 6px 8px;
            }
        }
  
        &.state4 {
            background-color: $state-color4;
        }
  
  
        &.state5 {
            background-color: $state-color5;
        }

        &.state6 {
            background-color: $state-color6;
            &.wd {
                padding: 6px 8px;
            }
        }
  
        &.state0 {
            background-color: $state-color0;
        }
    }

    .state_type {
        position: relative;

    }
    .dropdown {
        
        text-align: center;
        width:100%;
        position: absolute;
        z-index:99;
        left: -15px;
        top: calc(100% + 5px);
        ;

    }

  .guide_page {
      left: -430px !important;
      top: 15px !important;
      padding:30px;
      background-color: $gmx-theme-color;
      border: 1px solid #bbb;
      box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.3);
      border-radius: 3px;
      padding:20px;
      box-shadow: 0px 0px 6px #0000003B !important;
      width:507px !important;
      .guide_msg {
          margin-left:10px;
      }

      > span {
          table {
              col {
                  width: revert-layer !important;
              }
              thead {

                  th {
                      background: #F6F7FA 0% 0% no-repeat padding-box;
                      height: 36px;
                      text-align: center;
                      font-size: 13px;
                      letter-spacing: -0.41px;
                      color: #333333;
                      border-left: 1px solid #DFE3E9;
                      
                  }

                  th:first-child {
                      border : 0;
                  }
              }
              
              tbody {

                  td {
                      padding:12px 10px;
                      font-size:  11px;
                      text-align: left;
                      font-weight: normal;
                      border-bottom: 1px solid #DFE3E9;
                      border-left: 1px solid #DFE3E9;
                      font-family: $font-type0;

                      .state_type  {
                         width:200px;
                          padding: 6px 16px;
                          font-size:12px;
                      }
                  }

                  td:first-child {
                      text-align: center;
                      border-left:0;
                  }
              }
              
          }
      }
  }
  </style>